module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0072.jpg?v=d0aae85b";